import SpriteSymbol from "../../.yarn/cache/svg-baker-runtime-npm-1.4.7-fbb2e3215b-925379c771.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../.yarn/cache/svg-sprite-loader-npm-6.0.11-0d03c2400c-ddbd5ea43d.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 192\" id=\"home\"><path d=\"M96 18.343l-64 64V176h128V82.343l-64-64zM80 168v-48h32v48H80zm72 0h-32v-56H72v56H40V85.657l56-56 56 56V168z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol